import { buildingMetrics as l } from "./index.js";
function o(i) {
  const n = [];
  for (const a of i)
    n.map((f) => f.name).includes(a.name) ? n.find((f) => f.name === a.name).value += a.value : n.push(Object.assign({}, a));
  if ([l.gia, l.nia, l.efficiency].every((a) => n.map((f) => f.name).includes(a))) {
    const a = n.find((e) => e.name === l.gia).value, f = n.find((e) => e.name === l.nia).value;
    n.find((e) => e.name === l.efficiency).value = a ? f / a : 0;
  }
  return u(l.ffl, i, n), u(l.maxHeight, i, n), t(l.indicativeFormFactor, i, n), n;
}
function u(i, n, c) {
  if (c.map((a) => a.name).includes(i)) {
    const a = n.filter((e) => e.name === i), f = Math.max(...a.map((e) => e.value));
    c.find((e) => e.name === i).value = f;
  }
}
function t(i, n, c) {
  if (c.map((a) => a.name).includes(i)) {
    const a = n.filter((e) => e.name === i), f = a.map((e) => e.value).reduce((e, s) => e + s) / a.length;
    c.find((e) => e.name === i).value = f;
  }
}
export {
  o as sumMetrics
};
//# sourceMappingURL=index11.js.map
